<div class="login-container">
  <div class="login-card">
    <div class="login-card-isotipo">
      <img src="img/logo.png" alt="" srcset="">
    </div>
    
    <p class="login-subtitle">Iniciar sesión</p>
    
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="input-group">
        <label class="input-label">Correo electrónico</label>
        <input 
          pInputText 
          type="email" 
          formControlName="email"
          placeholder="Ejemplo@mail.com"
          class="custom-input"
          [ngClass]="{ 'input-error': (f['email'].touched || submitted) && f['email'].errors }"
        >
        <div *ngIf="(f['email'].touched || submitted) && f['email'].errors" class="error-message">
          <div *ngIf="f['email'].errors['required']">El correo electrónico es requerido</div>
          <div *ngIf="f['email'].errors['email'] || f['email'].errors['customEmail']">Ingresa un correo electrónico válido</div>
        </div>
      </div>
      
      <div class="input-group">
        <label class="input-label">Contraseña</label>
        <p-password 
          formControlName="password"
          [toggleMask]="true"
          [feedback]="false"
          placeholder="**********"
          [inputStyleClass]="(f['password'].touched || submitted) && f['password'].errors ? 'p-password-input input-error' : 'p-password-input'"
        ></p-password>
        <div *ngIf="(f['password'].touched || submitted) && f['password'].errors" class="error-message">
          <div *ngIf="f['password'].errors['required']">La contraseña es requerida</div>
        </div>
      </div>
      
      <a class="forgot-password" (click)="forgotPassword()">¿Olvidaste tu contraseña?</a>
      
      <button 
        pButton 
        type="submit" 
        class="login-button"
        [disabled]="loginForm.invalid || loading"
      >
        <span *ngIf="!loading">Iniciar Sesión</span>
        <span *ngIf="loading">Iniciando sesión...</span>
     </button>
    </form>
  </div>
  <p-toast></p-toast>
</div>
